import { gql } from '@apollo/client';

export default gql`
  query getAnimalsPerTrains($trainNumbers: [String]!, $departureDate: String!) {
    getAnimalsPerTrains(trainNumbers: $trainNumbers, departureDate: $departureDate) {
      trainNumber
      total
      carriages {
        number
        carriage
      }
    }
  }
`;
